var React = require('react');

function CvInterests (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"fill-none stroke-focus","strokeWidth":"2.5","cx":"24","cy":"24","r":"22","key":0}),React.createElement("path",{"className":"fill-none stroke-foreground","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M24.1,17.4c0,0,2-3.4,5.7-3.2s6.2,2.8,6.8,5.3\nc0.7,2.5-0.4,4.6-0.4,4.6s-1.2,2.7-4,5.3s-8.1,6.5-8.1,6.5h-0.1c0,0-5.3-3.9-8.1-6.5s-4-5.3-4-5.3s-1.1-2.1-0.4-4.6s3.1-5.1,6.8-5.3\ns5.7,3.2,5.7,3.2H24.1z","key":1})]);
}

CvInterests.defaultProps = {"version":"1.0","className":"experience__icon","width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = CvInterests;

CvInterests.default = CvInterests;
